import { Component } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import isEmpty from 'src/app/lib/isEmpty';
import { BotService } from 'src/app/services/bot.service';
import { SocketService } from 'src/app/services/socket.service';
import { SpotService } from 'src/app/services/spot.service';
import { MarketPriceFacade } from 'src/app/store/marketprice';
import { PairFacade } from 'src/app/store/pair/pair.facade';

@Component({
  selector: 'app-exchage-list',
  templateUrl: './exchage-list.component.html',
  styleUrls: ['./exchage-list.component.css']
})
export class ExchageListComponent {

  public isMobileLayout = false;
  public isDestopLayout = false;
  chartData: any = {}
  pairData: any = {}
  chartStatus=false;
  cryptoPairs: any[] = [];
  selectedPair:any;
  tikerRoot: any;
 
  constructor(
    private spotService: SpotService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private socketService: SocketService,
    private service:BotService,
    private router: Router,
    private marketPriceFacade: MarketPriceFacade,
    private pairFacade: PairFacade,
    
  ) {
    
  }
  ngOnInit() {
    this.getPairs();
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1199;
    window.onload = () => this.isMobileLayout = window.innerWidth <= 1199;
   this.route.paramMap.subscribe(params => {
      this.tikerRoot = params.get('tikerRoot');
      if (!isEmpty(this.tikerRoot)) {
        this.socketService.emit("subscribe", this.tikerRoot.replace("_", ""));
      }
    });
  }

  ngOnDestroy() {
    if (!isEmpty(this.tikerRoot)) {
      this.socketService.emit("unSubscribe", this.tikerRoot.replace("_", ""));
    }
  }

  fetchDCAChart(selectedPair: any) {
    // console.log("selectedPairselectedPair",selectedPair)
    this.service.getOpenOChart({
      pair: selectedPair.tikerRoot,
      pairId: selectedPair._id,
      exchange: selectedPair.botstatus,
      botType: "GENIE",
    }).subscribe({
      next: (v: any) => {
        // console.log(v, '-------116')
        this.chartStatus = true
        this.chartData = v.result
        // this.testVar = ["Test 1"]
      },
      error: (err: any) => {
        // console.log(err, '-------117')
      },
      complete: () => { },
    });
  }

 getPairs() {
    this.service.getPairList()
      .subscribe({
        next: (v: any) => {
          if (v.success) {
            if (isEmpty(this.tikerRoot)) {
              let pair = `${v.result[0].firstCurrencySymbol}_${v.result[0].secondCurrencySymbol}`
              //this.router.navigateByUrl("/arbitrage_bot/" + pair)
              this.router.navigateByUrl("/arbitrage_bot/" + "XRP_USDT")
            } else {
              this.pairFacade.setPair(v.result)
              const selectedPair = v.result.find((el: any) => el.tikerRoot === this.tikerRoot.replace('_', ''))
              if(isEmpty(selectedPair)){
                window.location.href = '/arbitrage_bot/XRP_USDT'
              }
              this.pairData = selectedPair;
              this.marketPriceFacade.setSpotMarketPrice(selectedPair)
              this.service.setTradePair(selectedPair)
              this.fetchDCAChart(selectedPair)
            }
          }
        },
        error: (err: any) => {
        }
      })
  }
  cancelOrder() {
    const orderId = localStorage.getItem('cancelOrderId')
    // console.log(orderId, 'getOrderId')
    if (orderId) {
      this.cancelorderApi(orderId)
    }
  }

  onPairChange(pair: any) {
    this.selectedPair = pair;}

  cancelorderApi(orderId: string) {
    this.spotService.cancelOrder(orderId).subscribe({
      next: (v: any) => {
        $("#cancelOrderModalBtn").click()
        this.toastr.success(v.message);
      },
      error: (err: any) => {
        console.log(err, 'err.error')
        this.toastr.error(err.error.message);
      }
    })
    const modalElement = document.getElementById('cancelorder_enable_modal');
    if (modalElement) {
      modalElement.classList.remove('show'); 
      modalElement.style.display = 'none'; 
    }
  }

  closeModel() {
    const modalElement = document.getElementById('cancelorder_enable_modal');
    if (modalElement) {
      modalElement.classList.remove('show'); 
      modalElement.style.display = 'none'; 
    }
    localStorage.removeItem('cancelOrderId')
  }

}

